module.exports = __webpack_public_path__ + "assets/img/guangqukeji2.a54ee93f.png";